import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import moment from 'moment';
import { useContextInfo } from '../../context/ContextInfo';
import { useForm } from '../../hooks/useForm';
import { fetchConToken } from '../../api/fetch';
import { RedContext } from '../../context/connection/ContextRed';
import { AuthContext } from '../../auth/AuthContext';
const day = moment().format('YYYY-MM-DD');
const initialState = {
    id: '',
    ref: '',
    monto: '',
    descri: '',
    tipo: 'INGRESO',
    fecha: day,
};
const ModIngreso = ({ show, onClose, item, callBk }) => {
    const { setResp } = useContextInfo();
    const { redState } = useContext(RedContext);
    const { auth } = useContext(AuthContext);

    const [load, setLoad] = useState(false);
    const [validated, setValidated] = useState(false);
    const [values, handleInputChange, reset, setFormValue] = useForm({ ...initialState });
    const { id } = values;
    useEffect(() => {
        !show ? setFormValue({ ...initialState }) : setFormValue({ ...values, ...item });
    }, [show]);

    const funClose = () => {
        if (id) {
            onClose();
        } else {
            reset();
            onClose();
        }
    };
    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let res = await fetchConToken(`plus/ingresos`, { ...values, agente: auth.uid }, 'POST');
            setResp(res);
            callBk();
            reset();
            onClose();
        }
        setLoad(false);
    };
    return (
        <Modal show={show} onHide={funClose}>
            <Modal.Header onHide={funClose} closeButton>
                <h4 className="modal-title">{id ? 'Editar' : 'Nuevo'} registro</h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Form noValidate validated={validated} onSubmit={onSubmit}>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom999">
                                            <Form.Label>Monto</Form.Label>
                                            <Form.Control
                                                required
                                                type="number"
                                                value={values.monto}
                                                name="monto"
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                        <Form.Group className="mb-3" controlId="validationCustom022">
                                            <Form.Label>Tipo</Form.Label>
                                            <Form.Select
                                                value={values.tipo}
                                                name="tipo"
                                                required
                                                onChange={handleInputChange}>
                                                <option value="INGRESO">Ingreso</option>
                                                <option value="EGRESO">Egreso</option>
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="validationCusto">
                                            <Form.Label>Referencia</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                value={values.ref}
                                                name="ref"
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                        <Form.Group className="mb-3" controlId="validationCusto">
                                            <Form.Label>Fecha</Form.Label>
                                            <Form.Control
                                                required
                                                type="date"
                                                value={values.fecha}
                                                name="fecha"
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                        <Form.Group className="mb-3" controlId="validationCusto">
                                            <Form.Label>Descripción</Form.Label>
                                            <Form.Control
                                                as={'textarea'}
                                                type="text"
                                                value={values.descri}
                                                name="descri"
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                        {load ? (
                                            <Button color="primary" disabled>
                                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                                Guardando...
                                            </Button>
                                        ) : (
                                            <Button type="submit">Guardar</Button>
                                        )}
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};

export default ModIngreso;
